import { DAY_GRANULARITY, WEEK_GRANULARITY, MONTH_GRANULARITY, ALL_GRANULARITY } from '../../constants/analytics';
import { DATE_RANGE_DAY, DATE_RANGE_WEEK, DATE_RANGE_MONTH } from '../../constants/cenariusDimensions';

type Column = { key: string };

export abstract class DrilldownMapperBase {
  protected granularityToDimensionMap = {
    [DAY_GRANULARITY]: DATE_RANGE_DAY,
    [WEEK_GRANULARITY]: DATE_RANGE_WEEK,
    [MONTH_GRANULARITY]: DATE_RANGE_MONTH,
  };

  protected dimensionToGranularityMap = {
    [DATE_RANGE_DAY]: DAY_GRANULARITY,
    [DATE_RANGE_WEEK]: WEEK_GRANULARITY,
    [DATE_RANGE_MONTH]: MONTH_GRANULARITY,
  };

  protected _hasGranularityDimension?: boolean = undefined;

  constructor(
    protected selectedColumns: any[] = [],
    protected granularity: string = ALL_GRANULARITY,
    protected dimensions: string[] = [],
    protected activeHeader: string = ''
  ) {}

  protected get granularityIsAll() {
    return this.granularity === ALL_GRANULARITY;
  }

  protected get hasGranularityDimension() {
    if (this._hasGranularityDimension === undefined) {
      this._hasGranularityDimension = this.dimensions.some((d) => d in this.dimensionToGranularityMap);
    }
    return this._hasGranularityDimension;
  }

  abstract needsUpdate(): boolean;

  abstract getSelectedColumns(): Column[];

  abstract getDimensions(): string[];

  abstract getGranularity(): string | undefined;

  abstract getActiveHeader(): string;
}
